import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=007e1080"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports